"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewContractForm = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../../app");
const contract_1 = require("../../../model/contract");
const payment_1 = require("../../../model/payment");
const helpers_1 = require("../../../utils/helpers");
const alert_box_1 = require("../../../widgets/alert_box");
const form_for_1 = require("../../../widgets/form_for");
const modal_1 = require("../../../widgets/modal");
const notification_center_1 = require("../../../widgets/notification_center");
const right_panel_1 = require("../../../widgets/right_panel");
const client_table_1 = require("../client/client_table");
const contract_table_1 = require("./contract_table");
const user_conditions_print_1 = require("./user_conditions_print");
const moment = require("moment");
function getClients() {
    return exports.NewContractForm.clientList.map((client) => {
        return [client.id, [client.first_name, client.last_name, `(${client.id})`].join(" ")];
    });
}
function clientNeedToSignContract() {
    let client = exports.NewContractForm.clientList.find(v => v.id == exports.NewContractForm.contract.client_id);
    return client && !client.signed_contract;
}
function getCommercialOffers() {
    return exports.NewContractForm.commercialOfferList.map((co) => {
        return [co.id, `${co.name} (${co.id})`];
    });
}
function prefillWithCommercialOffer(obj) {
    if (obj.offer_id) {
        app_1.App.get(`/commercial_offers/${obj.offer_id}`).then((data) => {
            let co = data;
            obj.active = true;
            obj.free_cancel_minutes = co.free_cancel_minutes;
            obj.initial_minutes = co.total_minutes;
            obj.installment_count = co.installment_count;
            obj.start_at_creation = co.starts_at_creation;
            obj.validity_period = co.validity_period;
            obj.value = co.value.raw;
            obj.value_ttc = (0, helpers_1.withVAT)({ raw: obj.value }).raw;
        });
    }
}
function renderExpirationDate(obj) {
    if (obj.start_at_creation) {
        let expirationDate = moment().add(obj.validity_period, "month");
        return (0, mithril_1.default)("div", "Le forfait expirera le ", (0, mithril_1.default)("strong", expirationDate.format("LL")));
    }
    return undefined;
}
function renderConditions(form) {
    if (form.obj.offer_id) {
        return (0, form_for_1.fieldset)("Conditions", {}, form.field("Minutes d'annulation libre", "free_cancel_minutes", "number"), form.field("Période de validité (en mois)", "validity_period", "number"), (0, form_for_1.columns)(form.checkbox("Démarrage du forfait à la création?", "start_at_creation"), renderExpirationDate(form.obj)));
    }
    return undefined;
}
function renderPayment(payment) {
    return (0, form_for_1.columns)((0, mithril_1.default)("div", { class: "field", style: "text-align: center" }, (0, mithril_1.default)("label", { class: "label", style: "text-align: left" }, "Payé"), (0, form_for_1.checkbox)("", "paid", payment)), (0, form_for_1.field)("Montant", "amount", "number", payment, {
        renderValue: (0, helpers_1.renderMoneyInput)(),
        transformValue: (0, helpers_1.transformMoneyInput)()
    }), (0, form_for_1.field)("Date de paiement", "date", "date", payment, {}), (0, form_for_1.selectField)("Type", "type", payment_1.PAYMENT_TYPES, payment, {}));
}
function renderPaymentLines(form) {
    if (!form.obj.offer_id) {
        return undefined;
    }
    let payments = form.obj.payments;
    const installment_count = Math.max(0, form.obj.installment_count || 0);
    payments.length = installment_count;
    let out = [];
    for (let i = 0; i < installment_count; i++) {
        if (payments[i] == undefined) {
            payments[i] = {
                amount: { raw: form.obj.value_ttc / installment_count },
                date: moment().add(i, "month").format("YYYY-MM-DD"),
                type: "check"
            };
        }
        out.push(renderPayment(payments[i]));
    }
    return out;
}
function initPayments(form) {
    let payments = form.obj.payments;
    if (!payments) {
        payments = form.obj.payments = [];
    }
    const installment_count = form.obj.installment_count || 1;
    if (payments.length == installment_count)
        return;
    payments.length = installment_count;
    let amountPerPayment = Math.round(form.obj.value_ttc / installment_count);
    let remnant = (form.obj.value_ttc - (installment_count * amountPerPayment));
    // In case the sum is not divisible, we divide the payment so the first payment is one cent bigger
    let firstAmountPayment = amountPerPayment + remnant;
    for (let i = 0; i < installment_count; i++) {
        payments[i] = {
            amount: { raw: (i == 0 ? firstAmountPayment : amountPerPayment) },
            date: moment().add(i, "month").format("YYYY-MM-DD"),
            type: "check"
        };
    }
}
function isCreateDisabled(form) {
    return !form.obj.offer_id ||
        !form.obj.client_id ||
        isPaymentsIllegal(form) !== undefined;
}
function isPaymentsIllegal(form) {
    if (!form.obj.offer_id) {
        return ``;
    }
    let sum = Math.round(form.obj.value_ttc);
    let total = 0;
    form.obj.payments.forEach((x) => { total += x.amount.raw; });
    total = Math.round(total);
    if (sum != total) {
        return `La somme des paiements (${(0, helpers_1.moneyToString)({ raw: total })}) est differentes du prix du forfait (${(0, helpers_1.moneyToString)({ raw: sum })}) !`;
    }
    else {
        return undefined;
    }
}
function renderPaymentScheme(form) {
    if (!form.obj.offer_id) {
        return undefined;
    }
    initPayments(form);
    let message;
    if (message = isPaymentsIllegal(form)) {
        message = (0, mithril_1.default)("div", { class: "has-text-danger" }, message);
    }
    return (0, form_for_1.fieldset)("Paiements", {}, message, form.checkbox("Moyen de paiement reçu a la signature", "payment_received"), form.field("Nombre de paiements", "installment_count", "number", { min: 0 }), renderPaymentLines(form));
}
function renderHintSignContract(form) {
    if (clientNeedToSignContract()) {
        return (0, alert_box_1.alertBox)({
            content: (0, mithril_1.default)("div", "Nouveau client. Pensez à faire signer le contrat du client.", (0, mithril_1.default)("br"), (0, mithril_1.default)("a", { href: user_conditions_print_1.UserConditionsPrint.link(form.obj.client_id), target: "_blank" }, "Cliquez ici pour ouvrir le contrat.")),
            level: "info",
        });
    }
    return undefined;
}
function renderPricing(form) {
    if (form.obj.offer_id) {
        return (0, form_for_1.fieldset)("Tarification", {}, (0, form_for_1.columns)(form.field("Nombre de minutes", "initial_minutes", "number", { step: 30, min: 60 })), (0, form_for_1.columns)(form.field("Coût du forfait (HT)", "value", "number", {
            renderValue: (x) => {
                return Math.round(x) / 100;
            },
            transformValue: (x) => {
                let value = Math.round(parseFloat(x) * 100);
                form.obj.value_ttc = Math.round((app_1.App.VAT_RATE + 1) * value);
                return value;
            },
            step: 0.01,
            min: 0
        }), form.field("Prix total (TTC)", "value_ttc", "number", {
            renderValue: (x) => {
                return Math.round(x) / 100;
            },
            transformValue: (x) => {
                let value = Math.round(parseFloat(x) * 100);
                form.obj.value = Math.round(value / (app_1.App.VAT_RATE + 1));
                return value;
            },
            step: 0.01,
            min: 0
        })));
    }
    return undefined;
}
function renderForm(form) {
    return [
        form.errorBlock(),
        renderHintSignContract(form),
        (0, form_for_1.fieldset)("Général", {}, form.selectField("Offre", "offer_id", getCommercialOffers(), {
            oninput: (evt) => { form.obj.offer_id = evt.detail.value; prefillWithCommercialOffer(form.obj); }
        }), form.selectField("Client", "client_id", getClients())),
        renderPricing(form),
        renderPaymentScheme(form),
        renderConditions(form),
    ];
}
exports.NewContractForm = {
    contract: {},
    active: false,
    clientList: [],
    commercialOfferList: [],
    reset() {
        this.contract = {
            installment_count: 1
        };
    },
    fetchClients() {
        app_1.App.get("/clients/list").then((data) => {
            this.clientList = data;
        });
    },
    fetchCommercialOffers() {
        app_1.App.get("/commercial_offers/list").then((data) => {
            this.commercialOfferList = data;
        });
    },
    show(contract) {
        this.fetchClients();
        this.fetchCommercialOffers();
        if (contract) {
            this.contract = contract;
        }
        else {
            this.reset();
        }
        this.active = true;
    },
    title(form) {
        if (form.isNew()) {
            return `Nouveau forfait`;
        }
        else {
            return `Editer forfait #${form.obj.id}`;
        }
    },
    view(_vnode) {
        if (this.active) {
            let form = (0, form_for_1.formFor)(this.contract, contract_1.ContractFormProvider, (form) => {
                form.onbeforesubmit((mdl) => {
                    if (typeof (mdl.client_id) == "string") {
                        // Fix issue for some reason the type is string with select box if not changed first.
                        mdl.client_id = parseInt(mdl.client_id);
                    }
                });
                return (0, modal_1.modalCard)({
                    title: this.title(form),
                    content: renderForm(form),
                    foot: (0, mithril_1.default)("div", { class: "is-pulled-right" }, form.submit(form.isNew() ? "Créer" : "Mettre à jour", {
                        onsubmit: (obj) => {
                            notification_center_1.Notification.success(`Le forfait #${obj.id} a bien été créé.`, right_panel_1.RightPanel.linkTo("Afficher", "contracts", obj.id, "show"));
                            client_table_1.ClientTable.fetch();
                            contract_table_1.ContractTable.fetch();
                            exports.NewContractForm.active = false;
                        },
                        disabled: isCreateDisabled(form)
                    })),
                    isActive: exports.NewContractForm.active,
                    onClose: () => { exports.NewContractForm.active = false; }
                });
            });
            return form;
        }
        return undefined;
    }
};
